export const MIN_VISIBLE_LABEL_WIDTH = 70;
